<template>
    <div>
        <!-- TODO: Filters to drop and not overlay  -->
        <p class="location-filters__count-mobile">Showing all {{ activeLocations.length }} results</p>
        <div class="location-filters__wrapper" v-show="!loading && !error && locations && locations.length > 0">
            <FilterBar 
                :locations="locations" 
                :display="display" 
                :activeRegion="activeRegion" 
                :activeLocationCount="activeLocations.length" 
                @toggle-display="toggleDisplay" 
                @toggle-region="toggleRegion"
            />
        </div>
        
        <div class="locations__loading" v-if="loading">
            <LoadingIndicator />
        </div>

        <div class="container">
            <div v-if="!loading && !error" class="locations__results">
                <div v-if="display === 'grid'" class="locations__grid-view spacing-bottom--large">
                    <GridView :locations="activeLocations" />
                </div>
            </div>
        </div>
        <div class="container">
            <div v-if="!loading && !error" class="locations__results">
                <div v-if="display === 'map'" class="locations__map-view spacing-bottom--large">
                    <MapView :locations="activeLocations" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import LocationService from '../../services/locations';

import GridView from "./GridView.vue";
import MapView from "./MapView.vue";
import FilterBar from "./FilterBar.vue";
import LoadingIndicator from "../Global/LoadingIndicator";

export default {
    props: ["title"],
    components: {
        MapView,
        GridView,
        FilterBar,
        LoadingIndicator
    },
    data() {
        return {
            error: false,
            loading: true,
            display: "grid",
            locations: [],
            regions: [],
            activeRegion: null,
            activeLocations: [],
        }
    },
    mounted() {
        this.getLocations();
    },
    watch: {
        locations: function () {
            let regions = [];
            this.locations.forEach((location) => {
                if (!regions.includes(location.region)) {
                    regions.push(location.region)
                }
            });
            this.regions = regions.sort((a, b) => (a.title > b.title) ? 1 : ((b.title > a.title) ? -1 : 0));
            this.activeLocations = this.locations.sort((a, b) => (a.title > b.title) ? 1 : ((b.title > a.title) ? -1 : 0));
        }
    },
    methods: {
        toggleRegion: function (key) {
            if (this.activeRegion === key) {
                this.activeRegion = null;
                this.activeLocations = this.locations
            } else {
                this.activeRegion = key;
                this.activeLocations = this.locations.filter((location) => {
                    return location.region === key;
                });
            }
        },
        toggleDisplay: function (display) {
            this.display = display;
        },
        getLocations: async function () {
            try {
                const locations = await LocationService.locations();
                this.locations = locations.locations;
                this.loading = false;
            } catch (error) {
                this.error = true;
                this.loading = false;
            }
        }
    }
}
</script>

